import type { ComponentProps, MouseEventHandler } from 'react'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import Caption from '../../../../LuxKit/Typography/Caption'
import TextLink from '../../../../LuxKit/TextLink'

interface Props {
  size: 'M' | 'L'
  onClick: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
}

const SIZES_CAPTION_WEIGHTS: Record<Props['size'], ComponentProps<typeof Caption>['weight']> = {
  M: 'normal',
  L: 'bold',
}

function IncludesTaxesAndFeesDetails(props: Props) {
  const {
    size,
    onClick,
  } = props

  const intl = useIntl()

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onClick(event)
  }, [onClick])

  return <Caption
    variant="medium"
    weight={SIZES_CAPTION_WEIGHTS[size]}
    colour="primary"
  >
    <TextLink onClick={handleClick}>
      {intl.formatMessage({
        id: 'XURIBitKriiPwSdvep7A',
        defaultMessage: 'Includes taxes and fees',
        description: 'Link label indicating that taxes and fees are included in the price',
      })}
    </TextLink>
  </Caption>
}

export default IncludesTaxesAndFeesDetails
